import { CommonModule as AngularCommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DnLoginModule, DnVerificationModule, DnForgotPasswordModule } from '@dn/libs/ui/dn-common';

import { config } from '../../environments/config';
import { LoginRoutingModule } from './login-routing.module';
import { CommonModule } from '../common/common.module';
import { LoginComponent } from './login.component';

@NgModule({
  declarations: [LoginComponent],
  imports: [
    AngularCommonModule,
    LoginRoutingModule,
    CommonModule,
    DnLoginModule.forRoot(config.name),
    DnVerificationModule.forRoot(config.name),
    DnForgotPasswordModule.forRoot(config.name),
  ],
})
export class LoginModule {}
